import React from 'react';
import { BusinessUnitSelect } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/pages/Selection/BusinessUnitSelect';
import { EntitySelect } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/pages/Selection/EntitySelect';
import { RetailerSelect } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/pages/Selection/RetailerSelect';
import { SegmentSelect } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/pages/Selection/SegmentSelect';
import { usePresentationFormContext } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/PresentationFormContext';
import WeekRangeSelect from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/pages/Selection/WeekRangeSelect';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { CategoryAndSubcategorySelect } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/pages/Selection/CategoryAndSubcategorySelect';
import { isFieldVisible } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/constants/formConfigs';

export const PresentationsSelectionPage = () => {
  const {
    selections: { watch },
    currentFormConfig
  } = usePresentationFormContext();

  const entityType = watch('entityType');

  // entityId controls ALL entity-related visibility
  const showEntitySection = isFieldVisible(currentFormConfig, 'entityId');

  // Determine which entity sub-component to render based on entityType selection
  const renderEntitySubComponent = () => {
    if (!showEntitySection || !entityType?.id) return null;

    if (entityType.id === 'category') {
      return <CategoryAndSubcategorySelect />;
    }
    if (entityType.id === 'segment') {
      return <SegmentSelect />;
    }
    if (entityType.id === 'businessunit') {
      return <BusinessUnitSelect />;
    }

    return null;
  };

  return (
    <Flex gap={64} flexDirection="column">
      <WeekRangeSelect />
      
      {/* Entity Type Selection - controlled by entityId visibility */}
      {showEntitySection && <EntitySelect />}
      
      {/* Retailer Selection - only show if visible */}
      {isFieldVisible(currentFormConfig, 'retailerIds') && <RetailerSelect />}
      
      {/* Entity sub-component (Category/Segment/BusinessUnit) - controlled by entityId visibility */}
      {renderEntitySubComponent()}
      
      {/* Note: Brand selection is ALWAYS on Brands step, never here */}
    </Flex>
  );
};
